/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {CreateByNameRequest} from "../model/create-by-name-request";
import {CreateScenarioGroupRequest} from "../model/create-scenario-group-request";
import {DeleteBatchScenarioRequest} from "../model/delete-batch-scenario-request";
import {DeleteScenarioRequest} from "../model/delete-scenario-request";
import {DuplicateScenarioRequest} from "../model/duplicate-scenario-request";
import {ListData} from "../model/list-data";
import {Scenario} from "../model/scenario";
import {ScenarioGroup} from "../model/scenario-group";
import {ScenarioGroupView} from "../model/scenario-group-view";
import {SearchParamRequest} from "../model/search-param-request";
import {SuccessCreateResponse} from "../model/success-create-response";
import {SuccessResponse} from "../model/success-response";

@Injectable({
    providedIn: "root",
})
export class SimScenarioService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public createScenario(scenarioRequest: CreateByNameRequest) {
        return super.post<SuccessCreateResponse>(`/api/Scenario/CreateScenario`, scenarioRequest);
    }

    public createScenarioGroup(scenarioGroupRequest: CreateScenarioGroupRequest) {
        return super.post<SuccessCreateResponse>(`/api/Scenario/CreateScenarioGroup`, scenarioGroupRequest);
    }

    public deleteBatchScenario(request: DeleteBatchScenarioRequest) {
        return super.post<SuccessResponse>(`/api/Scenario/DeleteBatchScenario`, request);
    }

    public deleteScenario(scenarioRequest: DeleteScenarioRequest) {
        return super.post<SuccessResponse>(`/api/Scenario/DeleteScenario`, scenarioRequest);
    }

    public deleteScenarioGroup(scenarioGroup: ScenarioGroup) {
        return super.post<boolean>(`/api/Scenario/DeleteScenarioGroup`, scenarioGroup);
    }

    public downloadScenario_Url(scenarioId: string) {
        return super.getUrl(`/api/Scenario/DownloadScenario`, {scenarioId: scenarioId});
    }

    public duplicateScenario(scenarioRequest: DuplicateScenarioRequest) {
        return super.post<SuccessResponse>(`/api/Scenario/DuplicateScenario`, scenarioRequest);
    }

    public fetchFilteredScenarios(searchParameters: SearchParamRequest) {
        return super.get<ListData<Scenario>>(`/api/Scenario/FetchFilteredScenarios`, {searchParameters: searchParameters}, ["searchParameters"]);
    }

    public getClinicalVignetteByScenarioId(scenarioId: string) {
        return super.get<string>(`/api/Scenario/GetClinicalVignetteByScenarioId`, {scenarioId: scenarioId});
    }

    public getDefaultScenario() {
        return super.get<Scenario>(`/api/Scenario/GetDefaultScenario`, );
    }

    public getFilteredScenarioGroups(searchTerm: string, searchColumn: string, sortColumn: string, sortAscending: boolean, page: number, pageSize: number) {
        return super.get<ListData<ScenarioGroup>>(`/api/Scenario/GetFilteredScenarioGroups`, {searchTerm: searchTerm, searchColumn: searchColumn, sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }
/**
 * @deprecated Deprecated, use FetchFilteredScenarios instead
 */ 

    public getFilteredScenarios(searchTerm: string = null, searchColumn: string = "name", sortColumn: string = "name", sortAscending: boolean = true, page: number = 0, pageSize: number = 2147483647) {
        return super.get<ListData<Scenario>>(`/api/Scenario/GetFilteredScenarios`, {searchTerm: searchTerm, searchColumn: searchColumn, sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public getScenarioById(scenarioId: string) {
        return super.get<Scenario>(`/api/Scenario/GetScenarioById`, {scenarioId: scenarioId});
    }

    public getScenarioByIds(scenarioIds: string[]) {
        return super.post<Scenario[]>(`/api/Scenario/GetScenarioByIds`, scenarioIds);
    }

    public getScenarioGroupById(scenarioGroupId: string) {
        return super.get<ScenarioGroup>(`/api/Scenario/GetScenarioGroupById`, {scenarioGroupId: scenarioGroupId});
    }

    public getScenarioGroups() {
        return super.get<ScenarioGroup[]>(`/api/Scenario/GetScenarioGroups`, );
    }

    public getScenariosGrouped() {
        return super.get<ScenarioGroupView[]>(`/api/Scenario/GetScenariosGrouped`, );
    }

    public listScenarios(searchTerm: string = null, sortColumn: string = "name", sortAscending: boolean = true, page: number = 0, pageSize: number = 2147483647) {
        return super.get<ListData<Scenario>>(`/api/Scenario/ListScenarios`, {searchTerm: searchTerm, sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public saveScenario(scenario: Scenario) {
        return super.post<SuccessResponse>(`/api/Scenario/SaveScenario`, scenario);
    }

    public upsertScenarioGroup(scenarioGroup: ScenarioGroup) {
        return super.post<boolean>(`/api/Scenario/UpsertScenarioGroup`, scenarioGroup);
    }
}